import React, {memo, useCallback, useMemo, useState} from 'react';

import './index.scss';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {useSelector} from 'react-redux';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {GatewayModel} from '../../../../types/gateway';
import {useMessage} from '../../../../hooks/message';
import {useQuestion} from '../../../../hooks/question';
import {useRPC} from '../../../../hooks/rpc';
import {GatewayCommand} from '../../../../types/control';

const columns: ColumnModel[] = [
    {
        length: 3,
        name: 'Gateway Adı',
        key: 'name',
    },
    {
        length: 2,
        name: 'Tip',
        key: 'type',
    },
    {
        length: 2,
        name: 'IP Adresi',
        key: 'ip_address',
    },
];

export const GATEWAY_TYPES = {
    '1': 'Nova Panel',
    '2': 'Home Manager',
};

const keyExtractor = (item: GatewayModel) => item.id;

export const GatewayListScreen = memo(function GatewayListScreen() {
    const {success} = useMessage();
    const question = useQuestion();
    const [rpc] = useRPC();

    const gatewayList = useSelector(state => state.control.gatewayList);

    const [selectedGateway, setSelectedGateway] = useState<GatewayModel>(null);

    const onRestartClick = useCallback(() => {
        question(`${selectedGateway.name} yeniden başlatılacaktır. Devam edilsin mi?`, () => {
            success('Yeniden başlatılıyor...');
            rpc.manageGateway(selectedGateway.id, GatewayCommand.Reboot);
        });
    }, [
        rpc,
        question,
        selectedGateway,
        success,
    ]);

    const buttons = useMemo(() => [
        {
            text: 'YÖNET',
            url: `/settings/gateway-control/${selectedGateway ? selectedGateway.id : ''}`,
            className: 'red',
            hidden: !(selectedGateway),
        },
        {
            text: 'DEVREYE ALMA',
            url: `/settings/gateway/${selectedGateway ? selectedGateway.id : ''}/setup/match`,
            className: 'blue',
            hidden: !(selectedGateway),
        },
        {
            text: 'DÜZENLE',
            url: `/settings/gateway/edit/${selectedGateway ? selectedGateway.id : ''}`,
            className: 'orange',
            hidden: !(selectedGateway),
        },
        /*{
            text: 'GATEWAY OLUŞTUR',
            url: '/settings/gateway/edit',
            className: 'green',
        },*/
    ], [selectedGateway, onRestartClick]);

    const displayNameExtractor = useCallback((item: GatewayModel, column: ColumnModel) => {
        if (column.key === 'type') {
            return GATEWAY_TYPES[item.type_id];
        } else if (column.key === 'ip_address') {
            return item.settings.home_network.ip_address || '-';
        }

        return item[column.key] || '-';
    }, []);

    return (
        <PasswordContainer requiredRole='service' isFullscreen={true}>
            <SettingsPageContainer buttons={buttons} className='device-list-page' backUrl={'/settings'}>
                <SettingsList
                    columns={columns}
                    items={gatewayList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedGateway}
                    onItemSelected={setSelectedGateway}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
